import { Component, OnInit } from '@angular/core';

interface IqacFunction {
  title: string;
  description: string;
}

interface IqacMember {
  sno: number;
  name: string;
  designation: string;
  position: string;
}

@Component({
  selector: 'app-category-page-one',
  templateUrl: './category-page-one.component.html',
  styleUrls: ['./category-page-one.component.scss']
})
export class CategoryPageOneComponent implements OnInit {
  iqacFunctions: IqacFunction[] = [
    {
      title: 'Developing and Implementing Quality Policies',
      description:
        'IQAC helps formulate and implement policies related to quality improvement across academic, administrative, and institutional areas.'
    },
    {
      title: 'Planning and Evaluation',
      description:
        'IQAC plans and conducts assessments to evaluate academic and administrative activities through benchmarks, data collection, and analysis.'
    },
    {
      title: 'Academic Program Review',
      description:
        'IQAC reviews curriculum, teaching-learning processes, and academic programs and suggests improvements wherever necessary.'
    },
    {
      title: 'Monitoring Internal Processes',
      description:
        'IQAC monitors admissions, examinations, governance, and internal administrative procedures to ensure alignment with quality standards.'
    },
    {
      title: 'Feedback and Continuous Improvement',
      description:
        'IQAC collects feedback from students, faculty, employers, and other stakeholders to identify gaps and implement corrective measures.'
    },
    {
      title: 'Faculty Development',
      description:
        'IQAC promotes faculty development by encouraging better pedagogy, professional growth, training, and research participation.'
    },
    {
      title: 'Research and Innovation',
      description:
        'IQAC supports research culture and innovation among faculty and students, encouraging academic excellence and creativity.'
    },
    {
      title: 'Institutional Accreditation',
      description:
        'IQAC plays a central role in preparing the institution for accreditation, ensuring compliance with standards and documentation.'
    },
    {
      title: 'Data Management',
      description:
        'IQAC maintains important institutional data repositories that support planning, reporting, decision-making, and quality review.'
    },
    {
      title: 'Benchmarking',
      description:
        'IQAC compares institutional performance with peer institutions to identify best practices and improvement opportunities.'
    },
    {
      title: 'Collaboration',
      description:
        'IQAC facilitates collaboration with external agencies, industry partners, and other institutions to strengthen quality enhancement.'
    }
  ];

  iqacMembers: IqacMember[] = [
    {
      sno: 1,
      name: 'Dr. P. Nelson Raja',
      designation: 'Professor & Principal',
      position: 'Chairperson'
    },
    {
      sno: 2,
      name: 'Dr. R. Natarajan',
      designation: 'Professor – EEE',
      position: 'Coordinator'
    },
    {
      sno: 3,
      name: 'Dr. V. Anbumalar',
      designation: 'Professor, Mechanical Engineering, Velammal College of Engineering & Technology, Madurai',
      position: 'External Academician'
    },
    {
      sno: 4,
      name: 'Mr. C. Rajadurai',
      designation: 'Associate Professor – Embedded Systems Technologies',
      position: 'Management Representative'
    },
    {
      sno: 5,
      name: 'Dr. K. R. Ramela',
      designation: 'Professor – Embedded Systems Technologies',
      position: 'Member'
    },
    {
      sno: 6,
      name: 'Dr. G. Dhinesh',
      designation: 'Professor – MBA',
      position: 'Member'
    },
    {
      sno: 7,
      name: 'Dr. S. Saravana Kumar',
      designation: 'Professor – Automobile Engineering',
      position: 'Member'
    },
    {
      sno: 8,
      name: 'Mr. J. Thavaseelan',
      designation: 'Associate Professor – Civil Engineering',
      position: 'Member'
    },
    {
      sno: 9,
      name: 'Dr. P. Ravikumaran',
      designation: 'Professor – Computer Science Engg',
      position: 'Member'
    },
    {
      sno: 10,
      name: 'Ms. M. Aishwarya',
      designation: 'Assistant Professor – EEE',
      position: 'Member'
    },
    {
      sno: 11,
      name: 'Mr. A. Athimoolam',
      designation: 'Associate Professor – S & H',
      position: 'Member'
    },
    {
      sno: 12,
      name: 'Mr. M. Prabakaran',
      designation: 'Associate Professor – Mechanical',
      position: 'Member'
    },
    {
      sno: 13,
      name: 'Ms. S. Hema',
      designation: 'Administrative Officer',
      position: 'Member'
    },
    {
      sno: 14,
      name: 'Mrs. A. VijayaArumugam',
      designation: 'Panchayat President',
      position: 'Village Administration'
    },
    {
      sno: 15,
      name: 'Mr. K. Ruban',
      designation: 'Student (2023-2027 Batch), Electrical and Electronics Engineering',
      position: 'Student Member'
    },
    {
      sno: 16,
      name: 'Mr. G. RajaGopalan',
      designation: 'PragbeesInfotech, Madurai',
      position: 'Alumni Member'
    },
    {
      sno: 17,
      name: 'Mr. M. MohammedFaiyaz',
      designation: 'Technical Head, Apptiva Solutions, Madurai',
      position: 'Employer'
    },
    {
      sno: 18,
      name: 'Mr. S. Sakthivel',
      designation: 'Proprietor, The Silicon Harvest, Madurai',
      position: 'Industrialist'
    },
    {
      sno: 19,
      name: 'Mrs. M. Gomathi',
      designation: 'Mother of M. Surutheeswari, ECE (2023-2027 Batch)',
      position: 'Parent'
    }
  ];

  constructor() {}

  ngOnInit(): void {}

  trackByTitle(index: number, item: IqacFunction): string {
    return item.title;
  }

  trackBySno(index: number, item: IqacMember): number {
    return item.sno;
  }
}